<rask-container-block>
    @if (form) {
    <form [formGroup]="form">
        <div class="row">
            <rask-input formControlName="namn" class="col-2"
                [required]="true"
                [label]="texts.namn"
                [rule]="validation.namn"
                aid="namn">
            </rask-input>
            <rask-input formControlName="beteckning" class="col-1"
                [readonly]="true"
                [label]="texts.beteckning"
                aid="beteckning">
            </rask-input>
            <rask-selector formControlName="produktgrupp" class="col-2"
                [required]="true"
                [label]="texts.produktgrupp"
                [raskDisabledControl]="produktgruppDisabled"
                [rule]="validation.produktgrupp"
                [values]="produktgrupperItems"
                [formatter]="produktgruppFormatter"
                [viewFormatter]="produktgruppViewFormatter"
                (change)="onProduktgruppChange($event)"
                aid="produktgrupp">
            </rask-selector>
            <rask-multi-selector formControlName="tradslag" class="col-4"
                [label]="texts.tradslag"
                [items]="tradslagItems"
                bindLabel="namn"
                bindValue="id"
                [viewFormatter]="tradslagViewFormatter"
                [viewSelectedFormatter]="tradslagViewSelectedFormatter"
                aid="tradslag">
            </rask-multi-selector>
            <rask-multi-selector formControlName="sortiment" class="col-3"
                [label]="texts.sortiment"
                [rule]="validation.sortiment"
                [items]="sortimentItems"
                bindLabel="kod"
                bindValue="id"
                [viewFormatter]="sortimentViewFormatter"
                [viewSelectedFormatter]="sortimentViewSelectedFormatter"
                aid="sortiment">
            </rask-multi-selector>
        </div>
        <div class="row">
            <div class="col-3">
                <rask-textarea formControlName="beskrivning" class="col-12 textbox-style"
                    [label]="texts.beskrivning"
                    [rule]="validation.beskrivning"
                    [rows]="6"
                    [maxlength]="1000"
                    aid="beskrivning">
                </rask-textarea>
            </div>
            <div class="col-2">
                <div class="row">
                    <rask-checkbox
                        formControlName="aktiv"
                        class="col-12 acktive-checkbox"
                        [label]="texts.aktiv"
                        aid="aktiv">
                    </rask-checkbox>
                </div>
                <div class="row">
                    <rask-input formControlName="skapadAv" class="col-12"
                        [readonly]="true"
                        [label]="texts.skapadAv"
                        aid="skapadAv">
                    </rask-input>
                </div>
            </div>
            <div class="col-4">
                <label for="relateradeHandelssortiment" class="col-form-label">
                    <span id="relateradeHandelssortiment">RELATERADE HANDELSSORTIMENT</span>
                </label>
                <div class="row">
                    @for (hs of produkt.koppladeHandelssortiment; track hs) {
                    <div>
                        <a [routerLink]="['/handelssortiment', hs.id]" class="relatedLink">{{hs.namn}} </a>
                        <a [routerLink]="['/handelssortiment', hs.id]" target="_blank">
                            <i class="far fa-sm fa-external-link p-r-half"></i>
                        </a>
                    </div>
                    }
                </div>
                <div class="row">
                    <rask-radiobutton-group formControlName="traddel"
                        [label]="texts.traddel"
                        [buttons]="traddelar"
                        aid="traddel">
                    </rask-radiobutton-group>
                </div>
            </div>
            <div class="col-3">
                <div class="row">
                    <rask-selector
                        class="col-12" label="ViolId"
                        formControlName="violId"
                        [formatter]="violOutputFormatter"
                        [viewSelectedFormatter]="violSelectedFormatter"
                        placeholder="Ange minst tre tecken"
                        [getSelectionFromModel]="getInitSelectedViolId"
                        [search]="searchForViolId" [viewFormatter]="violFormatter"></rask-selector>
                </div>
                <div class="row">
                    <div class="col-12 typ-checkboxes">
                        <rask-checkbox text="Produktion" formControlName="forProduktion"></rask-checkbox>
                        <rask-checkbox text="Inmätning" formControlName="forInmatning"></rask-checkbox>
                        <rask-checkbox text="Vrak" formControlName="vrak" [raskDisabledControl]="true"></rask-checkbox>
                    </div>
                </div>
            </div>
        </div>
    </form>
    }
</rask-container-block>